import find from 'lodash/find'
import filter from 'lodash/filter'

const getters = {
  basicsIsLoaded: state => {
    return state.isLoaded ? state.isLoaded : false;
  },
  basicStates: state => {
    return state.states ? state.states : [];
  },
  getStateById: state => id => find(state.states, ['id', id]),
  getStateNameById: state => id => {const s = find(state.states, ['id', id]); return s ? s.name : '';},
  companyDraftStateId: state => {
    if (!state.states)
      return -1
    const foundState = find(state.states, {state: 'draft', initiatedByCompany: true})
    return foundState && foundState.id ? foundState.id : -1
  },
  confirmedByCompany: state => {
    if (!state.states)
      return -1
    const foundState = find(state.states, {state: 'confirmedByCompany', initiatedByCompany: true})
    return foundState && foundState.id ? foundState.id : -1
  },
  confirmedByApprentice: state => {
    if (!state.states)
      return -1
    const foundState = find(state.states, {state: 'confirmedByApprentice', initiatedByCompany: true})
    return foundState && foundState.id ? foundState.id : -1
  },
  apprenticeDraftStateId: state => {
    if (!state.states)
      return -1
    const foundState = find(state.states, {state: 'draft', initiatedByCompany: false})
    return foundState && foundState.id ? foundState.id : -1
  },
  toApproveByCompanyStatesId: state => {
    if (!state.states)
      return -1
    //const foundStates = filter(state.states, {state: 'confirmedByStudent'})
    const foundStates =  filter(state.states, function(o) {
      return o.state==='confirmedByCompany' || o.state==='confirmedByStudent'
    })

    return foundStates && foundStates.length ? foundStates.map(o => {return o.id}) : []
  },

  allProfessions: state => {
    return state.allProfessions ? state.allProfessions : [];
  },
  getAllProfessionById: state => id => find(state.allProfessions, ['id', id]),
  getAllProfessionNameById: state => id => {const s = find(state.allProfessions, ['id', id]); return s ? s.name : '';},
  getAllProfessionIconById: state => id => {const s = find(state.allProfessions, ['id', id]); return s ? s.icon : 'question';},
  hasAllProfessionOrientations: state => id => {
    const p = find(state.allProfessions, ['id', id])
    return Boolean(p && p.machineOrientations && p.machineOrientations.length>0)
  },

  basicProfessions: state => {
    return state.professions ? state.professions : [];
  },
  getProfessionById: state => id => find(state.professions, ['id', id]),
  getProfessionNameById: state => id => {const s = find(state.professions, ['id', id]); return s ? s.name : '';},
  getProfessionIconById: state => id => {const s = find(state.professions, ['id', id]); return s ? s.icon : 'question';},
  hasProfessionOrientations: state => id => {
    const p = find(state.professions, ['id', id])
    return Boolean(p && p.machineOrientations && p.machineOrientations.length>0)
  },

  basicRegions: state => {
    return state.regions ? state.regions : [];
  },
  getRegionById: state => id => find(state.regions, ['id', id]),
  getRegionNameById: state => id => {const s = find(state.regions, ['id', id]); return s ? s.name : '';},
  basicRegionaryEmails: state => {
    return state.regionaryEmails ? state.regionaryEmails : [];
  },
  getRegionaryEmailsById: state => id => find(state.regionaryEmails, ['id', id]),
  getRegionaryEmailsNameById: state => id => {const s = find(state.regionaryEmails, ['id', id]); return s ? s.name : '';},

  basicEmploymentTypes: state => {
    return state.employmentTypes ? state.employmentTypes : [];
  },
  getEmploymentTypeById: state => id => find(state.employmentTypes, ['id', id]),
  getEmploymentTypeNameById: state => id => {const s = find(state.employmentTypes, ['id', id]); return s ? s.name : '';},
  basicDistanceOrderStates: state => {
    return state.distanceOrderStates ? state.distanceOrderStates : [];
  },
  basicExtensionOrderStates: state => {
    return state.extensionOrderStates ? state.extensionOrderStates : [];
  },
  getOrderStateNameById: state => id => {const s = find(state.distanceOrderStates, ['id', id]); return s ? s.name : '';},
  toConfirmByCompanyOrderStateId: state => {
    if (!state.distanceOrderStates)
      return -1
    const foundState = find(state.distanceOrderStates, {state: 'sentToCompanyForApproval'})
    return foundState && foundState.id ? foundState.id : -1
  },
  systemSettings: state => {
    return state.systemSettings ? state.systemSettings : {};
  },

};

export default getters;
